import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["caption", "error", "label", "wrapperProps", "wrapperRef", "disabled", "invert", "forwardedRef", "withMobileOffset"];
import React, { forwardRef } from 'react';
import { combineRefs } from '@carnica/utils';
import { ControlWrapper } from "../ControlWrapper";
import { InputCore } from "./InputCore";
export var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var caption = props.caption,
    error = props.error,
    label = props.label,
    _props$wrapperProps = props.wrapperProps,
    wrapperProps = _props$wrapperProps === void 0 ? {} : _props$wrapperProps,
    wrapperRef = props.wrapperRef,
    disabled = props.disabled,
    invert = props.invert,
    forwardedRef = props.forwardedRef,
    withMobileOffset = props.withMobileOffset,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(ControlWrapper, _extends({
    caption: caption,
    disabled: disabled,
    error: error,
    invert: invert,
    label: label,
    ref: wrapperRef,
    withMobileOffset: withMobileOffset
  }, wrapperProps, {
    "data-t-id": "components-Input"
  }), /*#__PURE__*/React.createElement(InputCore, _extends({
    disabled: disabled,
    invert: invert,
    ref: combineRefs([ref, forwardedRef]),
    status: error ? 'error' : 'default'
  }, otherProps, {
    "data-t-id": "components-Input"
  })));
});